import { RecruitInterview } from './recruit/RcruitInterview';
import { LoadingScreenManager } from '@inc/LoadingScreenManager';
import { RecruitCultureSplide } from './recruit/RecruitCultureSplide';

import { Observable } from '@inc/Observable.js';
import { ScrollFire } from '@inc/ScrollFire.js';

export class RecruitPage {
  constructor() {
    // インタビューのアコーディオン
    this.interview = new RecruitInterview(document.querySelector('.p-recruit-list'));
    this.cultureSplide = new RecruitCultureSplide('.p-recruit-culture__slider .splide');
    this.cultureSplide.init();
    this.casesSplide = new RecruitCultureSplide('.p-recruit-culture__slider--cases .splide');
    this.casesSplide.init();

    // ローディング画面
    this.loading = new LoadingScreenManager({
      className: '.p-recruit-loading',
      logoClassName: '.p-recruit-loading__text',
      screenFadeOutDuration: '0.7s',
      logoFadeInDuration: '0.7s',
      logoFadeOutDuration: '0.5s',
      logoFadeInPauseDuration: '.8s',
      logoFadeOutPauseDuration: '.1s',
      localStorageKey: 'recruitLoadingShown',
      developmentMode: false
    });

    const navLinks = document.querySelectorAll('#recruit-fixed-menu a');
    const currentSection = new Observable(null);
    const beforeSection = new Observable(null);

    currentSection.subscribe((newSection, oldSection) => {
      beforeSection.value = oldSection;

      if (newSection === '#entry' || newSection === '#contact') {
        document.body.classList.add('is-view-recruit-entry');
      } else {
        document.body.classList.remove('is-view-recruit-entry');
      }

      navLinks.forEach((navLink) => {
        if (navLink.hash === newSection) {
          navLink.classList.add('is-active');
        } else {
          navLink.classList.remove('is-active');
        }
      });
    });

    // rootMarginに画面の半分の値を入れる
    const rootMargin = Math.floor(-(window.innerHeight / 8)) + 'px';

    new ScrollFire({
      targetSelector: '[data-scroll]',
      className: 'in-view',
      rootMargin,
      threshold: [0],
      onEnter: (element) => {
        currentSection.value = '#' + element.id;
      },
      onExit: (element) => {
        if (currentSection.value === '#' + element.id) {
          currentSection.value = beforeSection.value;
        }
      },
    });

    // #recruit-fixed-menuクリックでthisにクラスをtoggle（子要素
    const recruitFixedMenu = document.querySelector('#recruit-fixed-menu');
    recruitFixedMenu.addEventListener('click', () => {
      recruitFixedMenu.classList.toggle('is-active');
    });
  }
}
